<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :name="id"
      :disabled="somenteLeitura"
      :value="valor"
      class="form-control"
      @change="atualizar($event.target)"
    >
      <option v-if="mostrarTodos" value=""> Todos </option>
      <option v-else disabled value=""> Selecione </option>
      <option value="true">Ativo</option>
      <option value="false">Cancelado</option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'SelecionarAtivo',
  mixins: [campoMixin],
  props: {
    mostrarTodos: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'Situação',
    },
    id: {
      type: String,
      default: 'situacao',
    },
  },
}
</script>
